import React from 'react'
import { useForm, FormProps } from './useForm'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Form.module.scss'

const Form: React.FC<FormProps> = (props: FormProps) => {
  const {
    isOtherDisplayed,
    supportFormData,
    method,
    amount,
    otherAmount,
    setMethod,
    setAmount,
    setOtherAmount,
    handleControllerChange,
    handleFormSubmit,
    t,
  } = useForm(props)

  return (
    <div className={styles['support-form']}>
      <h3>{t('donate')}</h3>
      <form onSubmit={handleFormSubmit}>
        <div className='row gy-4'>
          <div className='col-12'>
            <input
              type='text'
              name='name'
              className='form-control'
              placeholder={t('labelName')}
              title={t('requiredInput')}
              value={supportFormData.name}
              onChange={handleControllerChange}
              required
            />
          </div>
          <div className='col-12'>
            <input
              type='tel'
              className='form-control'
              name='phone'
              placeholder={t('labelPhone')}
              title={t('requiredInput')}
              value={supportFormData.phone}
              onChange={handleControllerChange}
              required
            />
          </div>
          <div className='col-12'>
            <select
              className='form-select'
              name='method'
              value={method}
              onChange={(e) => setMethod(e.target.value)}
              required
            >
              <option value='none' selected>
                {t('donationMethod')}
              </option>
              <option value='Wish Money'>Whish Money</option>
              <option value='Cash'>Cash</option>
              <option value='Western Union'>Western Union</option>
            </select>
          </div>
          <div className='col-12'>
            <select
              className='form-select'
              name='amount'
              value={amount}
              onChange={(e) => setAmount(+e.target.value)}
              required
            >
              <option value={0} selected>
                {t('labelAmount')}
              </option>
              <option value={1}>1$</option>
              <option value={5}>5$</option>
              <option value={10}>10$</option>
              <option value={25}>25$</option>
              <option value={50}>50$</option>
              <option value={100}>100$</option>
              <option value={101}>{t('other')}</option>
            </select>
          </div>
          <div
            className='col-12'
            style={{ display: isOtherDisplayed ? 'initial' : 'none' }}
          >
            <input
              type='text'
              name='otherAmount'
              className='form-control'
              placeholder={t('labelOtherAmount')}
              value={otherAmount}
              onChange={(e) => setOtherAmount(+e.target.value)}
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(
                    e.key
                  )
                ) {
                  e.preventDefault()
                }
              }}
              required
            />
          </div>
          <div className='col-12'>
            <textarea
              className='form-control'
              name='note'
              rows={6}
              value={supportFormData.note}
              onChange={handleControllerChange}
              placeholder={t('labelNote')}
            ></textarea>
          </div>
          <div className='col-12 text-center'>
            <button type='submit' className='btn btn-secondary px-5 py-2'>
              <FontAwesomeIcon
                icon={['fas', 'hand-holding-heart']}
                style={{ marginInlineEnd: '8px' }}
              />
              {t('donateNow')}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Form
